import animationManager, {
  makeSequence,
} from "../../../../services/animation-manager";
import { mainDrawerHTMLSelector, RouteChangeCallbacks } from "./common";

export function registerBackToPreviousMenuSequence({
  onSlideMainDrawerOutEnd,
}: RouteChangeCallbacks): void {
  animationManager.register(
    "transitionPreviousLevelDoubleDrawer",
    makeSequence([
      [
        {
          elementSelector: "#side-drawer > div",
          animation: {
            className: `translate-backward-animation-out`,
          },
        },
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className: `translate-backward-animation-out`,
            cleanUpAfterAnimation: (element) => {
              element.style.display = "none";
            },
          },
          onEnd: onSlideMainDrawerOutEnd,
        },
      ],
      [
        {
          elementSelector: "#side-drawer > div",
          animation: {
            className: `translate-backward-animation-in`,
          },
        },
        {
          elementSelector: mainDrawerHTMLSelector,
          animation: {
            className: `translate-backward-animation-in`,
            cleanUpBeforeAnimation: (element) => {
              element.style.display = "block";
            },
          },
        },
      ],
    ]),
  );
}
